import PropTypes from "prop-types";
import Link from "next/link";
import "../styles/_call-to-action-blog.module.scss";

const CallToActionDocsLink = (props: { title: string, docsLink: string }) => {
    return <>
        <section className={`call-to-action-blog`}>
            <div className={'container'}>
                <div className={'d-flex'}>
                    <h2>{props.title}</h2>
                    <div className={"cta-buttons"}>
                        <Link href={"https://app.middleware.io/auth/register/"} target={"_blank"} className={"ahref-btn primary"}>Get Started Free</Link>
                        <Link href={props.docsLink} className={"ahref-btn secondary"}>View Docs</Link>
                    </div>
                </div>
            </div>
        </section>
    </>
}
CallToActionDocsLink.defaultProps = {
    title: "Get our latest articles delivered straight to your inbox",
    docsLink: "https://docs.middleware.io"
}

CallToActionDocsLink.propTypes = {
    title: PropTypes.string,
    docsLink: PropTypes.string
}
export default CallToActionDocsLink